
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M24 0H0V24H24V0Z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M0 0L24 24L0 0ZM24 0L0 24L24 0Z","fill":"black"}}),_c('path',{attrs:{"d":"M24 0L0 24M0 0L24 24L0 0Z","stroke":"white","stroke-width":"4.8"}}),_c('path',{attrs:{"d":"M12 0V24V0ZM0 12H24H0Z","fill":"black"}}),_c('path',{attrs:{"d":"M0 12H24M12 0V24V0Z","stroke":"white","stroke-width":"8"}}),_c('path',{attrs:{"d":"M12 0V24V0ZM0 12H24H0Z","fill":"black"}}),_c('path',{attrs:{"d":"M0 12H24M12 0V24V0Z","stroke":"#CF142B","stroke-width":"4.8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"white"}})])])])
          )
        }
      }
    